import { Component, OnInit } from "@angular/core";
import moment from "moment-timezone";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOAliasUrl } from "src/app/shared/models/OOAliasUrl.model";
import { v4 as uuidv4 } from "uuid";

@Component({
	selector: "app-alias-url-setup",
	templateUrl: "./alias-url-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class AliasUrlSetupComponent implements OnInit {
	cloneRecord: OOAliasUrl;

	loaded: boolean = false;

	moment: any = moment;

	venueAliases: OOAliasUrl[];
	venueAliasSelected: OOAliasUrl;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.getAliasForVenue(this.venueService.subscriptionVenue.value.key);
		if (this.venueService.subscriptionOOmenu.value.length === 0) {
			this.venueService.menuGet();
			this.venueService.subscriptionOOmenu.subscribe((ooMenu) => {});
		}
	}

	async getAliasForVenue(venueKey) {
		const resp = await this.focuslink.aliasGetAll(venueKey);
		this.venueAliases = resp.map((i) => {
			const aa = new OOAliasUrl(i);
			if (aa.menuKey) {
				aa.customMenu = this.venueService.subscriptionOOmenu.value.find((i) => i.key === aa.menuKey);
			}
			return aa;
		});
	}

	test() {
		console.log(`test`);
		this.venueAliases.push(
			new OOAliasUrl({
				alias: "test",
			})
		);
		console.log(this.venueAliases.length);
	}

	editAlias(rec: OOAliasUrl) {
		this.venueAliasSelected = rec;
		this.cloneRecord = { ...rec };
	}

	newAlias() {
		this.venueAliasSelected = new OOAliasUrl({
			venueKey: this.venueService.subscriptionVenue.value.key,
			created: new Date(),
			guid: uuidv4(),
		});
	}

	dashForSpace(alias: string) {
		while (alias.includes(" ")) {
			alias = alias.replace(/\s/g, "-");
		}
		return alias;
	}

	async save() {
		try {
			this.venueAliasSelected.alias = this.dashForSpace(this.venueAliasSelected.alias);
			const resp = await this.focuslink.aliasPost(this.venueService.subscriptionVenue.value.key, this.venueAliasSelected);
			const newAlias = new OOAliasUrl(resp);
			newAlias.customMenu = this.venueService.subscriptionOOmenu.value.find((i) => i.key === newAlias.menuKey);
			this.venueAliasSelected = undefined;

			const existing = this.venueAliases.findIndex((i) => i.guid === newAlias.guid);
			if (existing === -1) {
				this.venueAliases.push(newAlias);
			} else {
				this.venueAliases[existing] = newAlias;
			}

			this.venueAliases = [...this.venueAliases];
		} catch (error) {
			this.app.msgSvc.add({ severity: "danger", detail: `${error.message}` });
		}
	}

	async delete(alias: OOAliasUrl) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete the "${alias.alias}" URL Alias?`,
			accept: async () => {
				this.focuslink.aliasDelete(alias.venueKey, alias.alias);
				this.venueAliases.splice(
					this.venueAliases.findIndex((i) => i.alias === alias.alias),
					1
				);
				this.venueAliasSelected = undefined;
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
